import { render, staticRenderFns } from "./duplicates.vue?vue&type=template&id=b2843330&scoped=true"
import script from "./duplicates.vue?vue&type=script&lang=js"
export * from "./duplicates.vue?vue&type=script&lang=js"
import style0 from "./duplicates.vue?vue&type=style&index=0&id=b2843330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2843330",
  null
  
)

export default component.exports